var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallfooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7185 7.95657C6.36739 9.23181 7.41281 10.2772 8.68805 10.9261L9.6794 9.93476C9.80557 9.80859 9.98131 9.77254 10.139 9.82211C10.6437 9.98884 11.1844 10.079 11.7477 10.079C11.8672 10.079 11.9818 10.1264 12.0663 10.2109C12.1509 10.2954 12.1983 10.4101 12.1983 10.5296V12.1067C12.1983 12.2262 12.1509 12.3408 12.0663 12.4254C11.9818 12.5099 11.8672 12.5573 11.7477 12.5573C9.71604 12.5573 7.76758 11.7503 6.33097 10.3136C4.89436 8.87704 4.08728 6.92858 4.08728 4.8969C4.08728 4.77739 4.13476 4.66278 4.21926 4.57827C4.30377 4.49376 4.41838 4.44629 4.53789 4.44629H6.11504C6.23455 4.44629 6.34917 4.49376 6.43367 4.57827C6.51818 4.66278 6.56566 4.77739 6.56566 4.8969C6.56566 5.46017 6.65578 6.00091 6.8225 6.50559C6.87207 6.66331 6.83602 6.83905 6.70985 6.96522L5.7185 7.95657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallfooter);
export default __webpack_public_path__ + "static/media/callfooter.1547f00fa48391034af634ec7a0faeee.svg";
export { ForwardRef as ReactComponent };